import React from "react";
import styles from "./StatusTag.module.scss";

const COLORS = {
  BLACK: styles.black,
  OUTLINE: styles.outline,
  GREEN: styles.green,
  BLUE: styles.blue,
  ORANGE: styles.orange,
  GREY: styles.grey,
  RED: styles.red,
}

const SIZES = {
  MEDIUM: styles.mediumSize,
}

const StatusTag = (props) => {
  const { color, size, text, className, alt, title, noMargin, noMarginTop } = props;

  if (!color || !(text || props.children)) {
    return null;
  }

  const classes = [
    styles.module,
    className,
    color,
    size,
    noMargin ? styles.noMargin: null,
    noMarginTop ? styles.noMarginTop: null,
    alt ? styles.alt : null,
  ];

  return <span title={title} className={classes.join(" ")}>{props.children}{text}</span>;
}

StatusTag.COLORS = COLORS;
StatusTag.SIZES = SIZES;

StatusTag.defaultProps = {
  size: SIZES.MEDIUM,
}

export default StatusTag;
